import { createFileRoute } from "@tanstack/react-router";
import BatchesJournal from "@/features/harvest-journal/batches-journal";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";

export const Route = createFileRoute("/harvests/$session_id/batches")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();

  return (
    <JournalPage>
      <BatchesJournal sessionId={session_id} />
    </JournalPage>
  );
}
